/* Djurslottet - Om oss: sifferbandet raknar upp nar det scrollas in i bild.
   Lugnt tempo med mjuk inbromsning, sa siffrorna hinner lasas. */
(function () {
  var els = document.querySelectorAll('[data-dj-count]');
  if (!els.length) return;

  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fmt(n) {
    try { return n.toLocaleString('sv-SE'); } catch (e) { return String(n); }
  }

  function run(el) {
    var target = parseInt(el.getAttribute('data-dj-count'), 10);
    if (isNaN(target)) return;
    var suffix = el.getAttribute('data-dj-suffix') || '';
    if (reduced) { el.textContent = fmt(target) + suffix; return; }

    var dur = 2800;
    var t0 = null;
    function tick(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(Math.round(target * eased)) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  if (!('IntersectionObserver' in window)) {
    for (var i = 0; i < els.length; i++) run(els[i]);
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      run(e.target);
    });
  }, { threshold: 0.4 });
  for (var j = 0; j < els.length; j++) io.observe(els[j]);
})();
